export enum HWTransferMethodType {
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  BANK_CARD = 'BANK_CARD',
  PAPER_CHECK = 'PAPER_CHECK',
  PAYPAL_ACCOUNT = 'PAYPAL_ACCOUNT',
  PREPAID_CARD = 'PREPAID_CARD',
  VENMO_ACCOUNT = 'VENMO_ACCOUNT',
  WIRE_ACCOUNT = 'WIRE_ACCOUNT',
}
